import { useMemo } from "react";
import useWindowSize from "../hooks/useWindowSize";

const useIsMobileHook = () => {
  const window = useWindowSize();

  const isMobile = useMemo(() => {
    return window.width <= 767;
  }, [window.width]);

  return isMobile;
};

export default useIsMobileHook;
